/**
 * SuperCache can store any object with string keys.
 * It handles expiration and maximum capacity.
 */
class SuperCache {
	/**
	 * @param {number} expiration In seconds
	 * @param {number} capacity How many items we're allowed to store
	 */
	constructor(expiration: number, capacity: number) {
		if (expiration <= 0)
			throw new Error("Expiration must be set to a non-zero value");
		if (capacity <= 0)
			throw new Error("Capacity must be set to a non-zero value");

		/** @type {number} In seconds */
		(this as any).expiration = expiration;

		/** @type {number} */
		(this as any).capacity = capacity;

		/** @type {Object.<string, {value: *, added: Date}>} */
		(this as any).map = {};

		/** @type {Array<string>} */
		(this as any).queue = [];
	}

	set(key: string, value: any) {
		this.delete(key);
		(this as any).map[key] = {value, added: new Date()};
		(this as any).queue.push(key);

		while ((this as any).queue.length > (this as any).capacity)
			this.delete((this as any).queue[0]);
	}

	get(key: string): any {
		if ((this as any).map[key] === undefined)
			return undefined;

		// @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
		const msSinceAdded = (new Date()) - (this as any).map[key].added;
		if (msSinceAdded > ((this as any).expiration * 1000)) {
			this.delete(key);
			return undefined;
		}

		return (this as any).map[key].value;
	}

	delete(key: string) {
		if ((this as any).map[key] === undefined)
			return;

		delete (this as any).map[key];

		const idx = (this as any).queue.indexOf(key);
		if (idx !== -1)
			(this as any).queue.splice(idx, 1);
	}

	clear() {
		(this as any).map = {};
		(this as any).queue = [];
	}
}

export default SuperCache;
